import _ from 'lodash';
import { getNbInCart, getProductId, removeUndefined, roundNumber, } from '../../../../../../../../utils';
import { ITEM_KEY_COUNTER_SEPARATOR } from '../../../../../../../../constants';
import { showMessageModal } from '../../../../../../../../redux/actions';
import store from '../../../../../../../../redux/store';
import { getOptionsData } from '../../ProductModal.services';
import { sendGoogleAnalytics } from '../../../../../../../../api';
import { analyticsEvents } from '../../../../../../../../utils/firebaseAnalytics';
import { updatePendingOrderBasket } from '../../../../../../../../api/pendingOrder';
import { logHighError } from '../../../../../../../../utils/logger';
import { Offer, } from '../../../../../../../../1_types/genericTypes';

export const calculatePrice = (
  items: any,
  shopCategories: any,
  price: number | string
): number => {
  let itemsPrice = 0;
  _.map(items, (item) => {
    const optionFree = shopCategories?.[item?.categoryKey]?.optionFree;
    if (item) {
      const itemOptions = _.values(item.options);
      _.map(itemOptions, (option, index) => {
        if (!optionFree || index >= optionFree) {
          itemsPrice += parseFloat(option.price);
        }
      });
    }
  });
  const productPrice = parseFloat(price.toString());
  return roundNumber(productPrice + itemsPrice);
};

type AddToCartClickParams = {
  product: any;
  productOffer?: Offer;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  mandatoryCategories: any;
  items: any;
  productCategories: any;
  shopCategories: any;
  sectionName: string;
  nb: number;
  sectionKey: any;
  productKey: any;
  instruction: any;
  unit: any;
  shopId: string;
  resetComponent: (notHide: boolean) => void;
};

export const addToCartClick = async ({
  product,
  productOffer,
  setLoading,
  mandatoryCategories,
  items,
  productCategories,
  shopCategories,
  sectionName,
  nb,
  sectionKey,
  productKey,
  instruction,
  unit,
  shopId,
  resetComponent,
}: AddToCartClickParams): Promise<void> => {
  const { name, price, key, position } = product;
  const {
    userConnected,
    user: { customerId },
    isUserAnonymous,
  } = store.getState().userReducer;
  try {
    setLoading(true);

    for (let i = 0; i < mandatoryCategories.length; i += 1) {
      const key = mandatoryCategories[i];
      if (!items[key]) {
        const categoryId = productCategories[key];
        const categoryKey = categoryId.split(ITEM_KEY_COUNTER_SEPARATOR)[0];
        const category = shopCategories?.[categoryKey];
        if (category) {
          const errorMessage = `Vous devez sélectionner l'option : ${category.name}`;
          store.dispatch(showMessageModal(errorMessage));
          setLoading(false);
        }
        return;
      }
    }
    const productId = getProductId(productKey, items, instruction, productOffer?.key);
    let cartNb = getNbInCart(productId) + Number(nb);
    let productPrice =
      calculatePrice(items, shopCategories, price) * cartNb;
    if (unit) {
      cartNb = Number(nb);
      productPrice =
        (calculatePrice(items, shopCategories, price) *
          cartNb) /
        unit.conversion;
    }
    const newProduct = { ...product };
    newProduct.items = getOptionsData(items);
    newProduct.nb = cartNb;
    newProduct.unit = unit ? unit.name : null;
    newProduct.sectionName = sectionName;
    newProduct.sectionKey = sectionKey;
    newProduct.productKey = productKey;
    newProduct.unitPrice = roundNumber(parseFloat(product.price));
    newProduct.price = roundNumber(productPrice);
    newProduct.shopId = shopId;
    newProduct.boughtPrice = !newProduct?.boughtPrice
      ? 0
      : roundNumber(newProduct.boughtPrice);
    if (instruction) {
      newProduct.instruction = instruction;
    }
    if (
      productOffer
    ) {
      newProduct.productMarketingCampaignKey = productOffer.key;
    }
    if (userConnected || isUserAnonymous) {
      newProduct.items = removeUndefined(newProduct.items);
      const { message } =
        (await updatePendingOrderBasket(customerId, {
          [productId]: newProduct,
        })) || {};
      if (message) store.dispatch(showMessageModal(message));
    }
    setTimeout(() => {
      resetComponent(false);
    }, 1000);
    sendGoogleAnalytics('add_to_cart', {
      currency: 'EUR',
      items: [
        {
          id: key,
          name,
          price,
          position,
          category: sectionName,
          quantity: nb,
        },
      ],
      value: productPrice,
    });
    analyticsEvents.logAddToCart(
      key,
      name,
      price,
      sectionName,
      nb,
      position,
      'EUR'
    );
  } catch (error) {
    logHighError(
      `Error adding product ${key} with items ${JSON.stringify(
        items
      )} to commande ${error}`
    );
  }
  setLoading(false);
};
